var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-template" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("router-link", {
          staticClass: "logo",
          attrs: { to: { name: "property-manager" } }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("h1", { staticClass: "login-page-header" }, [
          _vm._v("Reservations Lab Partner Portal ")
        ]),
        _vm._v(" "),
        _c(
          "form",
          { staticClass: "form-signin" },
          [
            !_vm.awaitingTwoFactor
              ? [
                  _c("h2", { staticClass: "form-signin-heading" }, [
                    _vm._v("Please sign in")
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "inputEmail" } },
                    [_vm._v("Email address")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.email,
                        expression: "email",
                        modifiers: { trim: true }
                      }
                    ],
                    ref: "email",
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      id: "inputEmail",
                      placeholder: "Email address",
                      autocomplete: "username",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.email
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.errors.email[0]) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "inputPassword" } },
                    [_vm._v("Password")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "password",
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      id: "inputPassword",
                      placeholder: "Password",
                      required: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary btn-block btn-flat",
                      class: { disabled: _vm.loading },
                      attrs: { disabled: _vm.loading || !_vm.captchaLoaded },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submit(
                            _vm.$refs.email.value,
                            _vm.$refs.password.value
                          )
                        }
                      }
                    },
                    [
                      _vm.loading
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v("\n          Signing In...\n        ")
                          ])
                        : !_vm.captchaLoaded
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v("\n          reCAPTCHA Loading...\n        ")
                          ])
                        : _c("span", [_vm._v("\n          Sign in\n        ")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.passkeysSupported
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-lg btn-default btn-block btn-flat",
                          class: {
                            disabled: _vm.loading || _vm.passkeyLoading
                          },
                          attrs: {
                            disabled: _vm.loading || _vm.passkeyLoading
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.signInWithPasskey.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _vm.passkeyLoading
                            ? _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin fa-fw"
                                }),
                                _vm._v(
                                  "\n          Waiting for passkey...\n        "
                                )
                              ])
                            : _c("span", [
                                _c("i", { staticClass: "fa fa-key" }),
                                _vm._v(
                                  "\n          Sign in with passkey\n        "
                                )
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right margin-top-1x" }, [
                    _c(
                      "a",
                      {
                        staticClass: "forgot-password",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openSendEmail.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("\n          Forgot your password?\n        ")]
                    )
                  ])
                ]
              : [
                  _c("h2", { staticClass: "form-signin-heading" }, [
                    _vm._v("Two-factor authentication")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Enter the code from your authenticator app.")
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "input2fa" } },
                    [_vm._v("Authenticator code")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.twoFactorCode,
                        expression: "twoFactorCode",
                        modifiers: { trim: true }
                      }
                    ],
                    ref: "twoFactorCode",
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "input2fa",
                      placeholder: "6-digit code",
                      maxlength: "8",
                      autocomplete: "one-time-code",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.twoFactorCode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.twoFactorCode = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.code
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n        " + _vm._s(_vm.errors.code[0]) + "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary btn-block btn-flat",
                      class: { disabled: _vm.loading },
                      attrs: { disabled: _vm.loading || !_vm.twoFactorCode },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitTwoFactor.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm.loading
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v("\n          Verifying...\n        ")
                          ])
                        : _c("span", [_vm._v("\n          Verify\n        ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right margin-top-1x" }, [
                    _c(
                      "a",
                      {
                        staticClass: "forgot-password",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.backToLogin.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("\n          Back to sign in\n        ")]
                    )
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "func-modal",
          {
            ref: "forgotPass",
            attrs: {
              title: "Reset Password",
              "data-backdrop": "static",
              "data-keyboard": "false"
            },
            scopedSlots: _vm._u([
              {
                key: "footer",
                fn: function(props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        class: { disabled: _vm.processing },
                        attrs: { disabled: _vm.processing },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.submitSendEmail(props)
                          }
                        }
                      },
                      [
                        _vm.processing
                          ? _c("span", [
                              _c("i", { staticClass: "fa fa-spin fa-spinner" }),
                              _vm._v("\n          Sending...\n        ")
                            ])
                          : _c("span", [_vm._v("\n          Send\n        ")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            props.close(), _vm.closeSendEmail()
                          }
                        }
                      },
                      [_vm._v("Close")]
                    )
                  ]
                }
              }
            ])
          },
          [
            _c("template", { slot: "body" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.forgotPass.email,
                    expression: "forgotPass.email"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "email", placeholder: "Type your email" },
                domProps: { value: _vm.forgotPass.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.forgotPass, "email", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.email
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errors.email[0]) + "\n      "
                    )
                  ])
                : _vm._e()
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "main-footer" }, [
      _c("div", { staticClass: "copyright" }, [
        _c("strong", [
          _vm._v("Copyright © "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("Reservations Lab")]),
          _vm._v(" " + _vm._s(_vm.year) + ".")
        ]),
        _vm._v(" All rights reserved.\n      ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-247e7dd8", { render: render, staticRenderFns: staticRenderFns })
  }
}